import React from 'react'
import BulkOutwardPreview from '../../../components/DispatchCentre/BlukOutward/Bin/Preview/BulkOutwardPreview'
import { Divider, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

const OutwardPreviewPage = () => {
    const navigate = useNavigate();

    const handleArrowClick = () => {
        navigate('/dispatch/bulkscan');
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    <div>
                        <>
                            <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />
                            Preview Outward Bins
                        </>
                    </div>

                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <BulkOutwardPreview />
        </>
    )
}

export default OutwardPreviewPage